import React from "react";
const Contact = () => {
  return (
    <section className="bg-center bg-cover bg-no-repeat h-full py-10 w-full bg-[linear-gradient(rgba(4,9,20,0.5),rgba(4,9,20,0.7)),url('../public/images/contactus.webp')]">
      <div className="px-5 py-10 m-auto flex flex-col gap-7 items-center text-center text-white">
        <h2 className="font-[700] text-[clamp(1rem,2vw,4rem)] capitalize">
          feel free to contact us for any inquiries or questions you may have
          and we will get back to you as soon as possible
        </h2>
        <a
          href="contact"
          className="mx-auto block text-center w-40 border-2 p-4 border-white rounded text-white font-semibold hover:border-[black] hover:bg-[black] hover:text-white transition uppercase"
        >
          contact us
        </a>
      </div>
    </section>
  );
};

export default Contact;
